import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=a9638834&scoped=true&"
import script from "./index-v2.vue?vue&type=script&lang=js&"
export * from "./index-v2.vue?vue&type=script&lang=js&"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=a9638834&lang=scss&scoped=true&"
import style1 from "./index-v2.vue?vue&type=style&index=1&id=a9638834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9638834",
  null
  
)

export default component.exports